import { useMemo } from "react";
export function useBrandSettings(images = {}) {
    const brand = useMemo(() => {
        const imageUrlsMap = {};
        for (const [type, imageList] of Object.entries(images)) {
            imageUrlsMap[type] = imageList.map(i => i.fileUrl);
        }
        return { images: imageUrlsMap };
    }, [images]);
    return {
        brand
    };
}
//# sourceMappingURL=useBrandSettings.js.map